import React from 'react';
import { motion } from 'framer-motion';

const NEABestBanner = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 text-white py-8 px-4 shadow-lg relative overflow-hidden"
    >
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left side - Logo */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="flex-shrink-0"
          >
            <img
              src="https://i.postimg.cc/Rh3b6BMv/NEAB-Vote-Badge.png"
              alt="NEA Best Badge"
              className="w-20 h-20 md:w-24 md:h-24 drop-shadow-lg"
            />
          </motion.div>

          {/* Center - Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="flex-1 text-center md:text-left"
          >
            <h2 className="text-2xl md:text-3xl font-bold mb-2 flex items-center justify-center md:justify-start gap-2">
              <span className="text-yellow-300">🏆</span>
              Winners of NEA Best!
            </h2>
            <p className="text-sm md:text-base mb-3 text-blue-100">
              We're honored to be recognized in three "service" categories:
            </p>
            <div className="flex flex-wrap justify-center md:justify-start gap-3 md:gap-4 mb-3">
              <span className="inline-flex items-center gap-1 text-sm md:text-base font-medium bg-white/20 px-3 py-1 rounded-full backdrop-blur-sm">
                ✨ Tax Services
              </span>
              <span className="inline-flex items-center gap-1 text-sm md:text-base font-medium bg-white/20 px-3 py-1 rounded-full backdrop-blur-sm">
                ✨ Accounting Firm
              </span>
              <span className="inline-flex items-center gap-1 text-sm md:text-base font-medium bg-white/20 px-3 py-1 rounded-full backdrop-blur-sm">
                ✨ Wealth Management
              </span>
            </div>
            <p className="text-sm md:text-base font-medium text-yellow-200 mb-2">
              Thank you to our community for your support.
            </p>
          </motion.div>

          {/* Right side - Winner photo */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="flex-shrink-0"
          >
            <img
              src="https://i.postimg.cc/QNzKry9F/SNOWS-NEA-WINNER-PHOTO-WITH-PLAQUES.jpg"
              alt="Snow holding the NEA Best winner plaques"
              className="w-64 h-44 md:w-72 md:h-48 object-cover rounded-lg shadow-lg"
            />
          </motion.div>
        </div>
      </div>

      {/* Bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-400"></div>
    </motion.section>
  );
};

export default NEABestBanner;